import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  position: relative;
  padding: 3px;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  position: absolute;
  top: -10px;
  right: -10px;
`

export const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`
